/**
 * Persisted open state for one sidebar.
 *
 * The app mounts two providers side by side, so the cookie name has to be
 * per-sidebar: sharing one made each panel overwrite the other's saved state.
 *
 * Its own module rather than part of `sidebar.tsx` because the reader is
 * needed outside the components: both providers are controlled from the `ui`
 * slice (the header, which sits between them and belongs to neither context,
 * has to read and toggle their state), so the initial read happens there.
 */
const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;

export function readStoredOpen(name: string): boolean | null {
  const match = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`,
    ),
  );
  if (!match) return null;
  return match[1] === "true";
}

export function writeStoredOpen(name: string, open: boolean) {
  document.cookie = `${name}=${open}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
}
